import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=3a785e52&scoped=true&lang=pug&"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts&"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=3a785e52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a785e52",
  null
  
)

export default component.exports